import { render } from "./PagerListLayout.vue?vue&type=template&id=0ae75dd4"
import script from "./PagerListLayout.vue?vue&type=script&lang=js"
export * from "./PagerListLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__